import React, { Component } from 'react';
import { Container, Card, Row, Col, Button, ButtonGroup, DropdownButton, Dropdown, Form, Spinner, Table, Modal, Badge, Tabs, Tab, Nav } from 'react-bootstrap';
import { t } from '../../helpers/translation_helper';
import NavBar from '../_partials/NavBar/_NavBar';
import Header from '../_partials/Header/_Header';
import { connect } from 'react-redux';
import { GET, POST } from '../../api';
import Pagination from '../_partials/Pagination';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faCheck, faEye, faEyeSlash, faFileExcel, faFileLines, faFolder, faGlobe, faImage, faList, faListCheck, faPencil, faPlus, faSearch, faTrash, faTrashCan, faUser, faXmark } from '@fortawesome/free-solid-svg-icons';
import { renderTableBody, renderTableHead } from '../../helpers/table_helper';
import { toast } from 'react-toastify';
import { handleFormErrors } from '../../helpers/form_helpers';
import moment from 'moment/moment';
import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import Select from 'react-select';
import SweetAlert from 'react-bootstrap-sweetalert';
import DatePicker from 'react-datepicker';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { getRegionalStorageURL } from '../../helpers/regional_storage_url_helper';
import GetIcon from '../../helpers/icon_helper';
import { Black, Concrete, Lotion, NewGray, PictonBlue, RedLustre, SilentPink, SoftGray, SpanishGray, Taurus, White, WhiteMarble } from '../../helpers/brand_colors_helper';
import { makeURL } from '../../helpers/general_helpers';

var Chance = require('chance');
var chance = new Chance();
const portalURL = process.env.REACT_APP_PORTAL_URL;

class Essay extends Component {

  docRef = React.createRef();

  defaultFormFields = {
    ib_essay_id: 0,
    ib_essay_name: '',
    ib_essay_acs: null,
    ib_essay_note: '',
    ib_essay_topic: '',
    ib_essay_research_question: '',
    ib_essay_supervisors: [],
    ib_essay_status: 'To Be Determined',
    ib_essay_approved: 0,
    ib_essay_completed: 0
  };

  defaultReflectionFields = {
    ib_essay_ref_id: 0,
    ib_essay_ref_title: '',
    ib_essay_ref_desc: '',
    ib_essay_id: 0,
    details: [],
    ib_essay_ref_date: new Date(),
  };

  defaultReflectionDetailFields = {
    ib_essay_refd_id: 0,
    ib_essay_refd_type: '',//URL', 'Image', 'File
    ib_essay_refd_value: '',
    ib_essay_refd_name: ''
  };

  defaultTodoFields = {
    ib_essay_todo_desc: '',
    ib_essay_todo_date: '',
  }

  state = {
    ...this.defaultTodoFields,
    activeTab: 'todo',
    ibEssayData: { ...this.defaultFormFields },
    ib_essay_status_data: ['Excellent', 'On Track', 'Concern', 'To Be Determined'],
    getSupervisorsData: [],
    acsData: [],
    deleteModal: { show: false, id: 0, action: () => { } },
    showFormModal: false,
    cdt: {
      fetching: false,
      search: '',
      rows: 10,
      offset: 0,
      order: 'academic_ib_essay.ib_essay_id',
      dir: 'DESC',
      lastPage: 0,
      page: 0,
      totalRecords: 0,
      rowsOptions: [10, 25, 50, 'All'],
      columns: [
        {
          id: 'academic_ib_essay.ib_essay_id',
          column: 'ib_essay_id',
          name: 'Actions',
          visibility: true,
          sortable: true,
        },
        {
          id: 'academic_ib_essay.ib_essay_name',
          column: 'ib_essay_name',
          name: 'Subject',
          visibility: true,
          sortable: true,
        },
        {
          id: 'academic_ib_essay.ib_essay_status',
          column: 'ib_essay_status',
          name: 'Status',
          visibility: true,
          sortable: true,
        },
        {
          id: 'academic_ib_essay.ib_essay_approved',
          column: 'ib_essay_approved',
          name: 'Approved',
          visibility: true,
          sortable: true,
        },
        {
          id: 'academic_ib_essay.ib_essay_completed',
          column: 'ib_essay_completed',
          name: 'Completed',
          visibility: true,
          sortable: true,
        },
      ],
      showTodoModal: false,
      data: [],
    },

    showDocumentModal: false,
    editDocumentModal: false,
    ib_essay_doc_id: 0,
    ib_essay_doc_caption: '',
    ib_essay_doc_name: '',
    ib_essay_doc_date: new Date(),
    EssayDocWorking: false,

    ib_essay_note_id: 0,
    ib_essay_note: '',
    showNoteModal: false,
    editNoteModal: false,
    EssayNoteWorking: false,

    showPlanningModal: false,
    editPlanningModal: false,
    ib_essay_plan_id: 0,
    ib_essay_plan_text: '',
    ib_essay_plan_date: new Date(),
    EssayPlanningWorking: false,

    // Reflection modal and form
    addReflectionModal: {
      show: false,
      working: false,
      isEditing: false,
      toggle: (addReflectionForm = { ...this.defaultReflectionFields }, isEditing = false) => {
        this.setState({
          addReflectionModal: { ...this.state.addReflectionModal, show: !this.state.addReflectionModal.show, working: false, isEditing },
          addReflectionForm
        })
      },
    },
    addReflectionForm: { ...this.defaultReflectionFields },
    getTimelineData: {
      fetching: false,
      search: '',
      data: []
    },
    showReflectionModal: {
      show: false,
      toggleModal: () => this.setState({ showReflectionModal: { ...this.state.showReflectionModal, show: !this.state.showReflectionModal.show, viewStyle: 'tab' } }),
      viewStyle: 'tab'//tab, timeline
    },
    refcdt: {
      fetching: false,
      search: '',
      rows: 10,
      offset: 0,
      order: 'essref.ib_essay_ref_id',
      dir: 'DESC',
      lastPage: 0,
      page: 0,
      totalRecords: 0,
      rowsOptions: [10, 25, 50, 'All'],
      columns: [
        {
          id: 'essref.ib_essay_ref_title',
          column: 'ib_essay_ref_title',
          name: 'Reflection Title',
          visibility: true,
          sortable: true,
        },
      ],
      data: [],
    },
    docscdt: {
      fetching: false,
      search: '',
      rows: 10,
      offset: 0,
      order: 'essaydocs.ib_essay_doc_id',
      dir: 'DESC',
      lastPage: 0,
      page: 0,
      totalRecords: 0,
      rowsOptions: [10, 25, 50, 'All'],
      columns: [
        {
          id: 'essaydocs.ib_essay_doc_id',
          column: 'ib_essay_doc_id',
          name: 'Actions',
          visibility: true,
          sortable: true,
        },
        {
          id: 'essaydocs.ib_essay_doc_caption',
          column: 'ib_essay_doc_caption',
          name: 'Document',
          visibility: true,
          sortable: true,
        },
        {
          id: 'essaydocs.ib_essay_doc_date',
          column: 'ib_essay_doc_date',
          name: 'Date',
          visibility: true,
          sortable: true,
        },
        {
          id: 'essaydocs.created_on',
          column: 'created_on',
          name: 'Created Date',
          visibility: true,
          sortable: true,
        },
      ],
      data: [],
    },
    notescdt: {
      fetching: false,
      search: '',
      rows: 10,
      offset: 0,
      order: 'essaynotes.ib_essay_note_id',
      dir: 'DESC',
      lastPage: 0,
      page: 0,
      totalRecords: 0,
      rowsOptions: [10, 25, 50, 'All'],
      columns: [
        {
          id: 'essaynotes.ib_essay_note_id',
          column: 'ib_essay_note_id',
          name: 'Actions',
          visibility: true,
          sortable: true,
        },
        {
          id: 'essaynotes.ib_essay_note',
          column: 'ib_essay_note',
          name: 'Note',
          visibility: true,
          sortable: true,
        },
      ],
      data: [],
    },
    todo: [],
    planningcdt: {
      fetching: false,
      search: '',
      rows: 10,
      offset: 0,
      order: 'essayplanning.ib_essay_plan_id',
      dir: 'DESC',
      lastPage: 0,
      page: 0,
      totalRecords: 0,
      rowsOptions: [10, 25, 50, 'All'],
      columns: [
        {
          id: 'essayplanning.ib_essay_plan_id',
          column: 'ib_essay_plan_id',
          name: 'Actions',
          visibility: true,
          sortable: true,
        },
        {
          id: 'essayplanning.ib_essay_plan_text',
          column: 'ib_essay_plan_text',
          name: 'Text',
          visibility: true,
          sortable: true,
        },
      ],
      data: [],
    },
  }

  componentDidMount() {
    const { search, rows: limit, order, dir } = this.state.cdt;
    this.fetch({
      search,
      limit,
      order,
      dir,
      page: 0,
    });
    this.getSupervisors()
    this.getSubjects()
  }

  getSubjects = async () => {
    this.setState({ subjects: null })
    const { authData, selectedChild } = this.props
    const { class_id, class_theme, agegroup_id } = selectedChild

    const params = {
      class_id,
      agegroup_id,
      class_theme,
    }

    try {
      const res = await GET('academic-subject-lessons/get-subjects', {
        params,
      })

      this.setState({
        acsData: res.data.data.map((v) => {
          return { ...v, label: v.acs_name, value: v.acs_id }
        }),
      })
    } catch (err) {
      toast.error('Something went wrong while fetching subjects!')
      console.log(err)
    }
  }

  getSupervisors = async () => {
    if (this.getSupervisorsReq) {
      this.getSupervisorsReq.abort();
    }
    this.getSupervisorsReq = new AbortController();
    const res = await GET('academic-ib-essay/get-supervisors', {
      signal: this.getSupervisorsReq.signal,
      params: {
        class_id: this.props.selectedChild.class_id
      },
    });
    if (res) {
      this.setState({ getSupervisorsData: res.data.map((v, i) => { return { ...v, label: v.full_name, value: v.user_id } }) })
    }
  }

  fetch = async (params) => {
    this.setState({
      cdt: {
        ...this.state.cdt,
        fetching: true,
      },
    });

    if (this.fetchReq) {
      this.fetchReq.abort();
    }
    this.fetchReq = new AbortController();

    try {
      const res = await GET('academic-ib-essay/get', {
        signal: this.fetchReq.signal,
        params: {
          search: params.search,
          order: params.order,
          dir: params.dir,
          limit: params.limit,
          offset: parseInt(params.page) * parseInt(params.limit),
        },
      });

      if (res.status === 200) {
        this.setState({
          cdt: {
            ...this.state.cdt,
            fetching: false,
            search: params.search,
            rows: parseInt(params.limit),
            offset: parseInt(params.page) * parseInt(params.limit),
            order: params.order,
            dir: params.dir,
            page: params.page,
            totalRecords: parseInt(res.data.total_count_filtered),
            lastPage: Math.ceil(
              parseInt(res.data.total_count_filtered) / parseInt(params.limit)
            ),
            data: res.data.data.map((item) => {
              return {
                uid: chance.guid(),
                ...item,
              };
            }),
          },
        });
      }
    } catch (err) {
      console.log('err', err);
      this.setState({
        cdt: {
          ...this.state.cdt,
          fetching: false,
        },
      });
    }
  };

  handleOpenFormModal = () => {
    this.setState({
      showFormModal: true,
      ibEssayData: { ...this.defaultFormFields }
    });
  };

  handleCloseFormModal = () => {
    this.setState({
      showFormModal: false,
      isEditing: false,
      ibEssayData: { ...this.defaultFormFields }
    });
  };

  handleCloseReflectionListModal = () => {
    this.setState({
      showReflectionModal: { ...this.state.showReflectionModal, show: false, viewStyle: 'tab' }
    });
  };

  showHideColumn = (column_index) => {
    const columns = this.state.cdt.columns;
    columns[column_index].visibility = !columns[column_index].visibility;
    this.setState({ ctd: { ...this.state.ctd, columns } });
  };

  exportExcel = async () => {
    const excelData = this.state.cdt.data.map((item) => {
      const row = {};
      this.state.cdt.columns
        .filter((column) => column.visibility)
        .map((column) => {
          if (column.name !== 'Actions') {
            row[column.name] = item[column.column];
          }
        });
      return row;
    });

    const fileName =
      'IB Essay Export ' + moment().format('DD-MM-YYYY');
    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const ws = XLSX.utils.json_to_sheet(excelData);

    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });

    FileSaver.saveAs(data, fileName + fileExtension);
  };

  saveUpdate = async () => {
    const { authData } = this.props;
    const { center_id } = authData.centerData;

    this.setState({ working: true });

    const ibEssayData = { ...this.state.ibEssayData };
    ibEssayData.ib_essay_supervisors = ibEssayData.ib_essay_supervisors.map((v) => v.value)
    ibEssayData.ib_essay_acs = (ibEssayData.ib_essay_acs) ? ibEssayData.ib_essay_acs.value : null

    const fData = new FormData();
    fData.append('ibEssayData', JSON.stringify(ibEssayData));
    fData.append('child_user_id', this.props.selectedChild.child_user_id);

    try {
      const res = await POST('academic-ib-essay/save', fData);
      if (res.data.type) {
        this.setState({
          working: false,
          showFormModal: false,
          isEditing: false,
          ibEssayData: this.defaultFormFields,
        });
        toast.success(t(res.data.message));
        this.fetch({
          search: '',
          limit: this.state.cdt.rows,
          order: this.state.cdt.order,
          dir: this.state.cdt.dir,
          page: 0,
        });
      } else {
        // toast.error(t(res.data.message));
        handleFormErrors(res.data.data);
        this.setState({ working: false });
      }
    } catch (err) {
      console.log('err', err);
      toast.error(t('Something went wrong!'));

      this.setState({ working: false });
    }
  };

  edit = (data) => {
    let thisData = JSON.parse(JSON.stringify(data))
    let ib_essay_supervisors = []
    JSON.parse(thisData.ib_essay_supervisors).map((v) => {
      let findSup = this.state.getSupervisorsData.find((vv) => vv.user_id == v)
      if (findSup) {
        ib_essay_supervisors.push(findSup)
      }
    })
    let findAcs = this.state.acsData.find((v, i) => v.value == thisData.ib_essay_acs)
    if (findAcs) {
      thisData.ib_essay_acs = findAcs
    }

    thisData.ib_essay_supervisors = ib_essay_supervisors
    this.setState({
      isEditing: true,
      showFormModal: true,
      ibEssayData: {
        ...thisData,
      }
    });
  }

  delete = async (data) => {
    this.setState({
      deleteModal: {
        ...this.state.deleteModal, show: true, id: data.ib_essay_id, action: async () => {
          try {
            const res = await GET('academic-ib-essay/delete', {
              params: {
                ib_essay_id: data.ib_essay_id,
              },
            });
            this.setState({
              cdt: {
                ...this.state.cdt,
                data: this.state.cdt.data.filter((item) => item.uid !== data.uid),
              },
              deleteModal: {
                ...this.state.deleteModal, show: false
              }
            });
            toast.success(t(res.data.message));
          } catch (err) {
            console.log(err);
            toast.error(t('Something went wrong!'));
          }
        }
      }
    })

  };

  viewEssay = (data) => {

    let thisData = JSON.parse(JSON.stringify(data))
    let ib_essay_supervisors = []
    JSON.parse(thisData.ib_essay_supervisors).map((v) => {
      let findSup = this.state.getSupervisorsData.find((vv) => vv.user_id == v)
      if (findSup) {
        ib_essay_supervisors.push(findSup)
      }
    })
    thisData.ib_essay_supervisors = ib_essay_supervisors

    this.setState({
      showReflectionModal: { ...this.state.showReflectionModal, show: true, },
      ibEssayData: {
        ...thisData,
      }
    }, () => {
      this.getReflections({
        search: '',
        limit: this.state.refcdt.rows,
        order: this.state.refcdt.order,
        dir: this.state.refcdt.dir,
        page: 0,
      });
      this.getDocs({
        search: '',
        limit: this.state.docscdt.rows,
        order: this.state.docscdt.order,
        dir: this.state.docscdt.dir,
        page: 0,
      });
      this.getNotes({
        search: '',
        limit: this.state.notescdt.rows,
        order: this.state.notescdt.order,
        dir: this.state.notescdt.dir,
        page: 0,
      });
      this.getPlanning({
        search: '',
        limit: this.state.planningcdt.rows,
        order: this.state.planningcdt.order,
        dir: this.state.planningcdt.dir,
        page: 0,
      });
      this.getTodo();
    });
  }

  getReflections = async (params) => {
    this.setState({
      refcdt: {
        ...this.state.refcdt,
        fetching: true,
      },
    });

    if (this.getReflectionsReq) {
      this.getReflectionsReq.abort();
    }
    this.getReflectionsReq = new AbortController();

    try {
      const res = await GET('academic-ib-essay/get-reflections', {
        signal: this.getReflectionsReq.signal,
        params: {
          search: params.search,
          order: params.order,
          dir: params.dir,
          limit: params.limit,
          offset: parseInt(params.page) * parseInt(params.limit),
          ib_essay_id: this.state.ibEssayData.ib_essay_id
        },
      });

      if (res.status === 200) {
        this.setState({
          refcdt: {
            ...this.state.refcdt,
            fetching: false,
            search: params.search,
            rows: parseInt(params.limit),
            offset: parseInt(params.page) * parseInt(params.limit),
            order: params.order,
            dir: params.dir,
            page: params.page,
            totalRecords: parseInt(res.data.total_count_filtered),
            lastPage: Math.ceil(
              parseInt(res.data.total_count_filtered) / parseInt(params.limit)
            ),
            data: res.data.data.map((item) => {
              return {
                uid: chance.guid(),
                ...item,
              };
            }),
          },
        });
      }
    } catch (err) {
      console.log('err', err);
      this.setState({
        refcdt: {
          ...this.state.refcdt,
          fetching: false,
        },
      });
    }
  };

  viewTodo = (data) => {

    let thisData = JSON.parse(JSON.stringify(data))
    let ib_essay_supervisors = []
    JSON.parse(thisData.ib_essay_supervisors).map((v) => {
      let findSup = this.state.getSupervisorsData.find((vv) => vv.user_id == v)
      if (findSup) {
        ib_essay_supervisors.push(findSup)
      }
    })
    thisData.ib_essay_supervisors = ib_essay_supervisors

    this.setState({
      showTodoModal: true,
      ibEssayData: {
        ...thisData,
      }
    }, () => {
      this.getTodo();
    });
  }

  getTodo = async () => {

    if (this.getTodoRequest) {
      this.getTodoRequest.abort();
    }
    this.getTodoRequest = new AbortController();

    try {
      const res = await GET('academic-ib-essay/get-todo', {
        signal: this.getTodoRequest.signal,
        params: {
          ib_essay_id: this.state.ibEssayData.ib_essay_id
        },
      });

      if (res.status === 200) {
        this.setState({
          todo: res.data.map((item) => {
            return {
              uid: chance.guid(),
              ...item,
            };
          })
        });
      }
    } catch (err) {
      console.log('err', err);
    }
  };

  addTodo = async () => {
    const { ib_essay_todo_desc, ib_essay_todo_date } = this.state;
    if (!ib_essay_todo_desc || !ib_essay_todo_date) {
      toast.error(t('Please fill all fields'));
      return;
    }

    this.setState({ working: true });

    const fData = new FormData();
    fData.append('ib_essay_todo_desc', ib_essay_todo_desc);
    fData.append('ib_essay_todo_date', moment(ib_essay_todo_date).format('YYYY-MM-DD'));
    fData.append('ib_essay_id', this.state.ibEssayData.ib_essay_id);

    try {
      const res = await POST('academic-ib-essay/save-todo', fData);
      if (res.data.type) {
        toast.success(t(res.data.message));
        this.setState({
          working: false,
          ...this.defaultTodoFields
        });
        this.getTodo();
      } else {
        // toast.error(t(res.data.message));
        handleFormErrors(res.data.data);
        this.setState({
          working: false,
        });
      }
    } catch (err) {
      console.log('err', err);
      toast.error(t('Something went wrong!'));

      this.setState({ working: false });
    }

  }

  deleteTodo = async (data) => {
    try {
      const res = await GET('academic-ib-essay/delete-todo', {
        params: {
          ib_essay_todo_id: data.ib_essay_todo_id,
        },
      });
      toast.success(t(res.data.message));
      this.getTodo();
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong!'));
    }
  };

  handleCloseTodoModal = () => {
    this.setState({
      showTodoModal: false,
      ...this.defaultTodoFields
    });
  };

  handleCloseDocumentModal = () => {
    this.setState({
      showDocumentModal: false,
      editDocumentModal: false,
      ib_essay_doc_id: 0,
      ib_essay_doc_caption: '',
      ib_essay_doc_name: '',
      ib_essay_doc_date: new Date(),
    });
  }

  saveUpdateEssayDoc = async () => {
    const { ib_essay_doc_id, ib_essay_doc_caption, ib_essay_doc_name, ib_essay_doc_date, editDocumentModal } = this.state;
    const { ib_essay_id } = this.state.ibEssayData;

    if (!ib_essay_doc_caption) {
      toast.error(t('Please enter document caption'));
      return;
    }

    if (!editDocumentModal && !ib_essay_doc_name) {
      toast.error(t('Please select a file'));
      return;
    }

    this.setState({ EssayDocWorking: true });

    const fData = new FormData();
    fData.append('ib_essay_doc_id', ib_essay_doc_id);
    fData.append('ib_essay_doc_caption', ib_essay_doc_caption);
    fData.append('ib_essay_doc_name', ib_essay_doc_name);
    fData.append('ib_essay_doc_date', moment(ib_essay_doc_date).format('YYYY-MM-DD'));
    fData.append('child_user_id', this.props.selectedChild.child_user_id);
    fData.append('ib_essay_id', ib_essay_id);

    try {
      const res = await POST('academic-ib-essay/save-essay-doc', fData);
      if (res.data.type) {
        this.setState({ EssayDocWorking: false });
        toast.success(t(res.data.message));
        this.getDocs({
          search: '',
          limit: this.state.docscdt.rows,
          order: this.state.docscdt.order,
          dir: this.state.docscdt.dir,
          page: 0,
        });
        this.handleCloseDocumentModal();
      } else {
        // toast.error(t(res.data.message));
        handleFormErrors(res.data.data);
        this.setState({ EssayDocWorking: false });
      }
    } catch (err) {
      console.log('err', err);
      toast.error(t('Something went wrong!'));

      this.setState({ EssayDocWorking: false });
    }
  }

  getDocs = async (params) => {
    const { ib_essay_id } = this.state.ibEssayData;

    this.setState({
      docscdt: {
        ...this.state.docscdt,
        fetching: true,
      },
    });

    if (this.getDocsReq) {
      this.getDocsReq.abort();
    }
    this.getDocsReq = new AbortController();

    try {
      const res = await GET('academic-ib-essay/get-documents', {
        signal: this.getDocsReq.signal,
        params: {
          search: params.search,
          order: params.order,
          dir: params.dir,
          limit: params.limit,
          offset: parseInt(params.page) * parseInt(params.limit),
          ib_essay_id
        },
      });

      if (res.status === 200) {
        this.setState({
          docscdt: {
            ...this.state.docscdt,
            fetching: false,
            search: params.search,
            rows: parseInt(params.limit),
            offset: parseInt(params.page) * parseInt(params.limit),
            order: params.order,
            dir: params.dir,
            page: params.page,
            totalRecords: parseInt(res.data.total_count_filtered),
            lastPage: Math.ceil(
              parseInt(res.data.total_count_filtered) / parseInt(params.limit)
            ),
            data: res.data.data.map((item) => {
              return {
                uid: chance.guid(),
                ...item,
              };
            }),
          },
        });
      }
    } catch (err) {
      console.log('err', err);
      this.setState({
        docscdt: {
          ...this.state.docscdt,
          fetching: false,
        },
      });
    }
  };

  editDoc = (data) => {
    this.setState({
      showDocumentModal: true,
      editDocumentModal: true,
      ib_essay_doc_caption: data.ib_essay_doc_caption,
      ib_essay_doc_date: new Date(data.ib_essay_doc_date),
      ib_essay_doc_id: data.ib_essay_doc_id,
    });
  };

  deleteDoc = async (data) => {
    try {
      const res = await GET('academic-ib-essay/delete-doc', {
        params: {
          ib_essay_doc_id: data.ib_essay_doc_id,
        },
      });
      this.setState({
        docscdt: {
          ...this.state.docscdt,
          data: this.state.docscdt.data.filter((item) => item.uid !== data.uid),
        },
      });
      toast.success(t(res.data.message));
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong!'));
    }
  }

  setIBEssayFormValue = (column, value) => {
    let { ibEssayData } = this.state
    ibEssayData[column] = value
    this.setState({ ibEssayData })
  }

  setReflectionValue = (column, value) => {
    let { addReflectionForm } = this.state
    addReflectionForm[column] = value
    this.setState({ addReflectionForm })
  }

  addReflectionDetail = (ib_essay_refd_type) => {
    let { addReflectionForm } = this.state
    addReflectionForm['details'].push({ ...this.defaultReflectionDetailFields, ib_essay_refd_type })
    this.setState({ addReflectionForm })
  }

  setReflectionDetailValue = (index, column, value) => {
    let { addReflectionForm } = this.state
    addReflectionForm['details'][index][column] = value
    this.setState({ addReflectionForm })
  };

  saveUpdateReflection = async () => {
    let { addReflectionForm, addReflectionModal } = this.state;
    addReflectionForm = { ...addReflectionForm }
    this.setState({ addReflectionModal: { ...addReflectionModal, working: true } });
    addReflectionForm.ib_essay_ref_date = moment(addReflectionForm.ib_essay_ref_date).format('YYYY-MM-DD')
    const fData = new FormData();
    addReflectionForm.details = addReflectionForm.details.map((v, i) => {
      if ((v.ib_essay_refd_type == 'File' || v.ib_essay_refd_type == 'Image') && v.ib_essay_refd_value?.name) {
        fData.append('reflectionFiles[' + i + ']', v.ib_essay_refd_value);
      }
      return { ...v }
    })
    fData.append('addReflectionForm', JSON.stringify(addReflectionForm));
    fData.append('child_user_id', this.props.selectedChild.child_user_id);

    try {
      const res = await POST('academic-ib-essay/save-reflection', fData);
      if (res.data.type) {
        addReflectionModal.toggle()
        toast.success(t(res.data.message));
        this.getReflections({
          search: '',
          limit: this.state.refcdt.rows,
          order: this.state.refcdt.order,
          dir: this.state.refcdt.dir,
          page: 0,
        });
      } else {
        // toast.error(t(res.data.message));
        handleFormErrors(res.data.data);
        this.setState({ working: false });
      }
    } catch (err) {
      console.log('err', err);
      toast.error(t('Something went wrong!'));

      this.setState({ working: false });
    }
  }

  editReflection = (data) => {
    console.log('data', data);
    this.state.addReflectionModal.toggle({
      ...data,
      ib_essay_ref_date: data.ib_essay_ref_date ? new Date(data.ib_essay_ref_date) : '',
      details: []
    }, true)
  }

  delRefDetail = async () => {
    const { id } = this.state.deleteModal;

    try {
      const res = await GET('academic-ib-essay/delete-reflection-detail', {
        params: {
          ib_essay_refd_id: id,
        },
      });
      this.getReflections({
        search: this.state.refcdt.search,
        limit: this.state.refcdt.rows,
        order: this.state.refcdt.order,
        dir: this.state.refcdt.dir,
        page: this.state.refcdt.page,
      });
      this.setState({ deleteModal: { show: false, id: 0, action: () => null } });
      toast.success(t(res.data.message));
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong!'));
    }
  }

  getNotes = async (params) => {
    const { ib_essay_id } = this.state.ibEssayData;

    this.setState({
      notescdt: {
        ...this.state.notescdt,
        fetching: true,
      },
    });

    if (this.getNotesReq) {
      this.getNotesReq.abort();
    }
    this.getNotesReq = new AbortController();

    try {
      const res = await GET('academic-ib-essay/get-notes', {
        signal: this.getNotesReq.signal,
        params: {
          search: params.search,
          order: params.order,
          dir: params.dir,
          limit: params.limit,
          offset: parseInt(params.page) * parseInt(params.limit),
          ib_essay_id
        },
      });

      if (res.status === 200) {
        this.setState({
          notescdt: {
            ...this.state.notescdt,
            fetching: false,
            search: params.search,
            rows: parseInt(params.limit),
            offset: parseInt(params.page) * parseInt(params.limit),
            order: params.order,
            dir: params.dir,
            page: params.page,
            totalRecords: parseInt(res.data.total_count_filtered),
            lastPage: Math.ceil(
              parseInt(res.data.total_count_filtered) / parseInt(params.limit)
            ),
            data: res.data.data.map((item) => {
              return {
                uid: chance.guid(),
                ...item,
              };
            }),
          },
        });
      }
    } catch (err) {
      console.log('err', err);
      this.setState({
        notescdt: {
          ...this.state.notescdt,
          fetching: false,
        },
      });
    }
  };

  handleCloseNoteModal = () => {
    this.setState({
      showNoteModal: false,
      editNoteModal: false,
      ib_essay_note_id: 0,
      ib_essay_note: ''
    });
  }

  saveUpdateEssayNote = async () => {
    const { ib_essay_id } = this.state.ibEssayData;
    const { ib_essay_note_id, ib_essay_note } = this.state;

    if (!ib_essay_note) {
      toast.error(t('Please enter note'));
      return;
    }


    this.setState({ EssayNoteWorking: true });

    const fData = new FormData();
    fData.append('ib_essay_note_id', ib_essay_note_id);
    fData.append('ib_essay_note', ib_essay_note);
    fData.append('child_user_id', this.props.selectedChild.child_user_id);
    fData.append('ib_essay_id', ib_essay_id);

    try {
      const res = await POST('academic-ib-essay/save-essay-note', fData);
      if (res.data.type) {
        this.setState({ EssayNoteWorking: false });
        toast.success(t(res.data.message));
        this.getNotes({
          search: '',
          limit: this.state.notescdt.rows,
          order: this.state.notescdt.order,
          dir: this.state.notescdt.dir,
          page: 0,
        });
        this.handleCloseNoteModal();
      } else {
        // toast.error(t(res.data.message));
        handleFormErrors(res.data.data);
        this.setState({ EssayNoteWorking: false });
      }
    } catch (err) {
      console.log('err', err);
      toast.error(t('Something went wrong!'));

      this.setState({ EssayNoteWorking: false });
    }
  }

  editNote = (data) => {
    this.setState({
      showNoteModal: true,
      editNoteModal: true,
      ib_essay_note: data.ib_essay_note,
      ib_essay_note_id: data.ib_essay_note_id,
    });
  };

  deleteNote = async (data) => {
    try {
      const res = await GET('academic-ib-essay/delete-note', {
        params: {
          ib_essay_note_id: data.ib_essay_note_id,
        },
      });
      this.setState({
        notescdt: {
          ...this.state.notescdt,
          data: this.state.notescdt.data.filter((item) => item.uid !== data.uid),
        },
      });
      toast.success(t(res.data.message));
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong!'));
    }
  }

  getPlanning = async (params) => {
    const { ib_essay_id } = this.state.ibEssayData;

    this.setState({
      planningcdt: {
        ...this.state.planningcdt,
        fetching: true,
      },
    });

    if (this.getPlanningReq) {
      this.getPlanningReq.abort();
    }
    this.getPlanningReq = new AbortController();

    try {
      const res = await GET('academic-ib-essay/get-planning', {
        signal: this.getPlanningReq.signal,
        params: {
          search: params.search,
          order: params.order,
          dir: params.dir,
          limit: params.limit,
          offset: parseInt(params.page) * parseInt(params.limit),
          ib_essay_id
        },
      });

      if (res.status === 200) {
        this.setState({
          planningcdt: {
            ...this.state.planningcdt,
            fetching: false,
            search: params.search,
            rows: parseInt(params.limit),
            offset: parseInt(params.page) * parseInt(params.limit),
            order: params.order,
            dir: params.dir,
            page: params.page,
            totalRecords: parseInt(res.data.total_count_filtered),
            lastPage: Math.ceil(
              parseInt(res.data.total_count_filtered) / parseInt(params.limit)
            ),
            data: res.data.data.map((item) => {
              return {
                uid: chance.guid(),
                ...item,
              };
            }),
          },
        });
      }
    } catch (err) {
      console.log('err', err);
      this.setState({
        planningcdt: {
          ...this.state.planningcdt,
          fetching: false,
        },
      });
    }
  };

  handleClosePlanningModal = () => {
    this.setState({
      showPlanningModal: false,
      editPlanningModal: false,
      ib_essay_plan_id: 0,
      ib_essay_plan_text: '',
      ib_essay_plan_date: new Date(),
    });
  }

  saveUpdateEssayPlanning = async () => {
    const { ib_essay_id } = this.state.ibEssayData;
    const { ib_essay_plan_id, ib_essay_plan_text, ib_essay_plan_date } = this.state;

    if (!ib_essay_plan_text) {
      toast.error(t('Please enter text'));
      return;
    }

    this.setState({ EssayPlanningWorking: true });

    const fData = new FormData();
    fData.append('ib_essay_plan_id', ib_essay_plan_id);
    fData.append('ib_essay_plan_text', ib_essay_plan_text);
    fData.append('ib_essay_plan_date', moment(ib_essay_plan_date).format('YYYY-MM-DD'));
    fData.append('child_user_id', this.props.selectedChild.child_user_id);
    fData.append('ib_essay_id', ib_essay_id);

    try {
      const res = await POST('academic-ib-essay/save-essay-planning', fData);
      if (res.data.type) {
        this.setState({ EssayPlanningWorking: false });
        toast.success(t(res.data.message));
        this.getPlanning({
          search: '',
          limit: this.state.planningcdt.rows,
          order: this.state.planningcdt.order,
          dir: this.state.planningcdt.dir,
          page: 0,
        });
        this.handleClosePlanningModal();
      } else {
        // toast.error(t(res.data.message));
        handleFormErrors(res.data.data);
        this.setState({ EssayPlanningWorking: false });
      }
    } catch (err) {
      console.log('err', err);
      toast.error(t('Something went wrong!'));

      this.setState({ EssayPlanningWorking: false });
    }
  }

  editPlanning = (data) => {
    this.setState({
      showPlanningModal: true,
      editPlanningModal: true,
      ib_essay_plan_id: data.ib_essay_plan_id,
      ib_essay_plan_text: data.ib_essay_plan_text,
      ib_essay_plan_date: new Date(data.ib_essay_plan_date),
    });
  };

  deletePlanning = async (data) => {
    try {
      const res = await GET('academic-ib-essay/delete-planning', {
        params: {
          ib_essay_plan_id: data.ib_essay_plan_id,
        },
      });
      this.setState({
        planningcdt: {
          ...this.state.planningcdt,
          data: this.state.planningcdt.data.filter((item) => item.uid !== data.uid),
        },
      });
      toast.success(t(res.data.message));
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong!'));
    }
  }

  renderCell = (column_data, column_id, column_index, dataObj) => {
    const { addReflectionModal } = this.state;

    let tdData;

    // Action Buttons
    if (column_id == 'ib_essay_id') {
      tdData = (
        <>
          <Button
            onClick={() => this.delete(dataObj)}
            title={t('Delete')}
            variant='danger'
            size='sm'
            className='me-1'>
            <FontAwesomeIcon icon={faTrash} />
          </Button>
          <Button
            onClick={() => this.edit(dataObj)}
            title={t('Edit')}
            variant='warning'
            size='sm'
            className='me-1'>
            <FontAwesomeIcon icon={faPencil} />
          </Button>
          {/* <Button
            onClick={() => addReflectionModal.toggle({ ...this.defaultReflectionFields, ib_essay_id: dataObj.ib_essay_id, details: [] }, false)}
            title={t('Add Reflection')}
            variant='info'
            size='sm'
            className='me-1'>
            <FontAwesomeIcon icon={faPlus} />
          </Button> */}
          <Button
            title='View Essay'
            onClick={() => this.viewEssay(dataObj)}
            variant='success'
            size='sm'
            className='me-1'>
            <FontAwesomeIcon icon={faFileLines} />
          </Button>
          {/* <Button
            title='Todo'
            onClick={() => this.viewTodo(dataObj)}
            variant='primary'
            size='sm'
            className='me-1'>
            <FontAwesomeIcon icon={faListCheck} />
          </Button> */}
        </>
      );
    } else if (column_id == 'ib_essay_approved' || column_id == 'ib_essay_completed') {
      tdData = <div className={(column_data) ? 'badge badge-light-success' : 'badge badge-light-danger'}>{(column_data) ? 'Yes' : 'No'}</div>
    } else {
      tdData = column_data;
    }

    return <td key={column_index}>{tdData}</td>;
  };


  getTimeline = async () => {
    const { getTimelineData, ibEssayData } = this.state;
    const { ib_essay_id } = ibEssayData
    this.setState({
      getTimelineData: {
        ...this.state.getTimelineData,
        fetching: true,
      },
    });

    if (this.getTimelineReq) {
      this.getTimelineReq.abort();
    }
    this.getTimelineReq = new AbortController();

    try {
      const res = await GET('academic-ib-essay/get-timeline', {
        signal: this.getTimelineReq.signal,
        params: {
          search: getTimelineData.search,
          ib_essay_id
        },
      });

      if (res.status === 200) {
        let uniqueDate = null
        this.setState({
          getTimelineData: {
            ...this.state.getTimelineData,
            fetching: false,
            search: getTimelineData.search,
            data: res.data.map((item) => {
              let uniqueDateFlag = false
              if (!(moment(uniqueDate).isSame(moment(item.date)))) {
                uniqueDateFlag = true
              }
              uniqueDate = moment(item.date).format('YYYY-MM-DD')
              return {
                uid: chance.guid(),
                uniqueDate: uniqueDateFlag ? item.date : null,
                hidden: false,
                ...item,
              };
            }),
          },
        });
      }
    } catch (err) {
      console.log('err', err);
      this.setState({
        getTimelineData: {
          ...this.state.getTimelineData,
          fetching: false,
        },
      });
    }
  };

  render() {
    // console.log('%cSTATE', 'font-size: 20px; font-weight: bold; color: orange', this.state);

    let { ibEssayData, getSupervisorsData, addReflectionModal, addReflectionForm, acsData, cdt, showReflectionModal, getTimelineData } = this.state
    return (
      <Container fluid>
        <div id='iedu-layout'>
          <NavBar />
          <div id='page-content'>
            <Header lite={true} heading={t('IB Essay')} backBtn />
            <div>
              <div className='d-flex flex-row align-items-center p-2'>
                <div style={{ flex: 1 }} className='pe-2'>
                  <div className='cdt-search' style={{ border: '#CFD4DA 1px solid', width: '100%', borderRadius: '20px', padding: '8px' }}>
                    <input
                      type='text'
                      defaultValue={this.state.cdt.search}
                      onChange={(e) =>
                        this.fetch({
                          search: e.target.value,
                          limit: this.state.cdt.rows,
                          order: this.state.cdt.order,
                          dir: this.state.cdt.dir,
                          page: 0,
                        })
                      }
                      placeholder={t('Search...')}
                    />
                  </div>
                </div>
                <div>
                  <button
                    onClick={() => this.fetch({
                      search: this.state.cdt.search,
                      limit: this.state.cdt.rows,
                      order: this.state.cdt.order,
                      dir: (this.state.cdt.dir == 'ASC') ? 'DESC' : 'ASC',
                      page: 0,
                    })}
                    style={{ height: 36, borderRadius: 20, minWidth: 100, paddingInline: 16, fontWeight: 'bold' }}
                    className='btn btn-light btn-sm me-2'>
                    <GetIcon icon={'LuArrowDownUp'} className={'me-2'} />
                    {t('SORT')}
                  </button>
                </div>
                <div>
                  <button
                    onClick={() => this.exportExcel()}
                    style={{ height: 36, borderRadius: 20, minWidth: 100, paddingInline: 16, fontWeight: 'bold', color: Taurus }}
                    className='btn btn-light btn-sm me-2'>
                    <GetIcon icon={'FaRegFileExcel'} className={'me-2'} />
                    {t('EXCEL')}
                  </button>
                </div>
                <div>
                  <button
                    onClick={this.handleOpenFormModal}
                    style={{ height: 36, borderRadius: 20, minWidth: 100, paddingInline: 16, fontWeight: 'bold', color: White }}
                    className='btn btn-primary btn-sm me-2'>
                    <GetIcon icon={'LuPlus'} className={'me-2'} />
                    {t('Add')}
                  </button>
                </div>
              </div>
            </div>
            <div className='grey-section p-3'>
              <div className='d-flex flex-row' style={{ fontSize: 12 }}>
                <div style={{ width: '100%', minHeight: '66vh', height: '66vh' }} className='d-flex'>
                  <div style={{ borderRadius: 25, flex: 1 }} className='d-flex flex-column'>
                    {/* TABLE BODY */}
                    <div style={{ flex: 1, overflowY: 'auto' }} className='p-2'>
                      <div style={{ width: '100%' }} className='d-flex flex-row flex-wrap align-items-stretch'>
                        {cdt.data.map((cdt_v, cdt_i) => {
                          return <div key={cdt_i} className='p-2 mb-2' style={{ width: '33.33%', }}>
                            <div style={{ backgroundColor: Lotion, borderRadius: 10, height: '100%' }} className='p-2 mb-2 d-flex flex-column'>
                              <div style={{ flex: 1, fontSize: 11 }} className='d-flex flex-row align-items-center mb-1'>
                                <GetIcon icon={'LuBookmark'} style={{ color: PictonBlue, fontSize: 14 }} />
                                <div className='ms-1' style={{ color: SpanishGray }}>{cdt_v.ib_essay_status}</div>
                              </div>
                              <div style={{ flex: 1, fontWeight: 'bold' }}>{cdt_v.ib_essay_name}</div>
                              <div style={{ flex: 1, fontSize: 11 }} className='d-flex flex-row align-items-center mt-1'>
                                <div style={{}}>{cdt_v.acs_name}</div>
                              </div>
                              <div style={{}} className='d-flex flex-row align-items-center mt-1'>
                                <div style={{ flex: 1 }} className='d-flex flex-row align-items-center'>
                                  <GetIcon icon={(cdt_v.ib_essay_completed) ? 'LuCircleCheck' : 'LuCircleX'} style={{ color: (cdt_v.ib_essay_completed) ? Taurus : RedLustre, fontSize: 16 }} />
                                  <div className='ms-1'>{t('Completed')}</div>
                                </div>
                                <div style={{ flex: 1 }} className='d-flex flex-row align-items-center'>
                                  <GetIcon icon={(cdt_v.ib_essay_approved) ? 'LuCircleCheck' : 'LuCircleX'} style={{ color: (cdt_v.ib_essay_approved) ? Taurus : RedLustre, fontSize: 16 }} />
                                  <div className='ms-1'>{t('Approved')}</div>
                                </div>
                              </div>
                              <div className='pt-2 d-flex flex-row align-items-center'>
                                <div style={{ width: '50%' }} className='px-1'>
                                  <Button variant='warning' size='sm' onClick={() => this.edit(cdt_v)} style={{ width: '100%' }} >
                                    <GetIcon icon={'LuPencil'} style={{ fontSize: 16 }} />
                                  </Button>
                                </div>
                                <div style={{ width: '50%' }} className='px-1'>
                                  <Button variant='outline-primary' size='sm' onClick={() => this.viewEssay(cdt_v)} disabled={(cdt_v.visitby_type == 2) ? true : false} style={{ width: '100%' }} >
                                    <GetIcon icon={'LuFile'} style={{ fontSize: 16 }} />
                                  </Button>
                                </div>
                              </div>

                            </div>
                          </div>
                        })}
                      </div>
                    </div>
                    {/* PAGINATION */}
                    <div className='d-flex justify-content-center align-items-center' style={{ borderTop: 'solid 1px ' + Concrete }}>
                      <Pagination
                        pageCount={this.state.cdt.lastPage || 1}
                        forcePage={this.state.cdt.page}
                        callbackParams={{
                          search: this.state.cdt.search,
                          limit: this.state.cdt.rows,
                          order: this.state.cdt.order,
                          dir: this.state.cdt.dir,
                        }}
                        callback={this.fetch}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* NEW/UPDATE MODAL IB ESSAY FORM */}
        <Modal backdrop='static' keyboard={false} size={'lg'} show={this.state.showFormModal} onHide={this.handleCloseFormModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.isEditing ? t('Edit') : t('Add')} {t('IB Essay')}
            </Modal.Title>
          </Modal.Header>
          {this.state.showFormModal &&
            <Modal.Body>
              <Row>
                <Col md={8}>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('Title')} <span className='text-danger'>*</span></Form.Label>
                    <Form.Control
                      type='text'
                      defaultValue={ibEssayData.ib_essay_name}
                      onChange={(e) =>
                        this.setIBEssayFormValue('ib_essay_name', e.target.value)
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={8}>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('Subject')} <span className='text-danger'>*</span></Form.Label>
                    <Select
                      classNamePrefix='custom-styled-select'
                      options={acsData}
                      onChange={(event) => this.setIBEssayFormValue('ib_essay_acs', event)}
                      value={ibEssayData.ib_essay_acs}
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('Topic')}</Form.Label>
                    <Form.Control
                      as='textarea'
                      rows='2'
                      defaultValue={ibEssayData.ib_essay_topic}
                      onChange={(e) =>
                        this.setIBEssayFormValue('ib_essay_topic', e.target.value)
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('Research Question')}</Form.Label>
                    <Form.Control
                      as='textarea'
                      rows='2'
                      defaultValue={ibEssayData.ib_essay_research_question}
                      onChange={(e) =>
                        this.setIBEssayFormValue('ib_essay_research_question', e.target.value)
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('Notes')}</Form.Label>
                    <Form.Control
                      as='textarea'
                      rows='2'
                      defaultValue={ibEssayData.ib_essay_note}
                      onChange={(e) =>
                        this.setIBEssayFormValue('ib_essay_note', e.target.value)
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('Supervisors')}</Form.Label>
                    <Select
                      classNamePrefix='custom-styled-select'
                      isMulti
                      closeMenuOnSelect={false}
                      options={getSupervisorsData}
                      onChange={(event) => this.setIBEssayFormValue('ib_essay_supervisors', event)}
                      value={ibEssayData.ib_essay_supervisors}
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}

                    />
                  </Form.Group>
                </Col>
              </Row>
            </Modal.Body>
          }
          <Modal.Footer>
            <Button variant='secondary' onClick={this.handleCloseFormModal}>
              {t('Close')}
            </Button>
            <Button
              disabled={this.state.working}
              variant={this.state.isEditing ? 'warning' : 'success'}
              onClick={() => this.saveUpdate()}>
              {this.state.isEditing ? t('Update') : t('Save')}{' '}
              {this.state.working && (
                <Spinner
                  as='span'
                  animation='grow'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                />
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* REFLECTION MODAL */}
        <Modal backdropClassName='second-backdrop' backdrop='static' keyboard={false} size={'lg'} show={addReflectionModal.show} onHide={addReflectionModal.toggle}>
          <Modal.Header closeButton>
            <Modal.Title>
              {addReflectionModal.isEditing ? t('Edit') : t('Add')} {t('Reflection')}
            </Modal.Title>
          </Modal.Header>
          {addReflectionModal.show &&
            <Modal.Body>
              <Row>
                <Col md={8}>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('Title')} <span className='text-danger'>*</span></Form.Label>
                    <Form.Control
                      type='text'
                      defaultValue={addReflectionForm.ib_essay_ref_title}
                      onChange={(e) =>
                        this.setReflectionValue('ib_essay_ref_title', e.target.value)
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('Date')}</Form.Label>
                    <div>
                      <DatePicker
                        selected={addReflectionForm.ib_essay_ref_date}
                        onChange={(date) =>
                          this.setReflectionValue('ib_essay_ref_date', date)
                        }
                        selectsStart
                        dateFormat={'dd-MM-yyyy'}
                      />
                    </div>
                  </Form.Group>
                </Col>
                <Col md={12} className='ck-editor-ht-200'>
                  <Form.Group className='mb-3'>
                    <Row>
                      <Col> <Form.Label>{t('Notes')}</Form.Label></Col>
                    </Row>
                    <CKEditor
                      config={{
                        removePlugins: ['Title'],
                        toolbar: {
                          items: [
                            'heading',
                            '|',
                            'bold',
                            'italic',
                            'alignment',
                            '|',
                            'numberedList',
                            'bulletedList',
                            '|',
                            'indent',
                            'outdent',
                            '|',
                            'undo',
                            'redo'
                          ]
                        }
                      }}
                      editor={Editor}
                      data={addReflectionForm.ib_essay_ref_desc}
                      onChange={(
                        event,
                        editor
                      ) => {
                        const ib_essay_ref_desc = editor.getData();
                        this.setReflectionValue('ib_essay_ref_desc', ib_essay_ref_desc);
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              {/* {!addReflectionModal.isEditing && */}
              <Row>
                <Col className='d-flex flex-row'>
                  <Button variant='info' size='sm' className='me-2' onClick={() => this.addReflectionDetail('URL')}>Add URL</Button>
                  <Button variant='info' size='sm' className='me-2' onClick={() => this.addReflectionDetail('Image')}>Add Image</Button>
                  <Button variant='info' size='sm' className='me-2' onClick={() => this.addReflectionDetail('File')}>Add File</Button>
                </Col>
              </Row>
              {/* } */}
              <Row>
                {addReflectionForm.details.map((v, i) => {
                  return <Col key={i} md="6">
                    <div className='border p-1 m-1'>
                      <Form.Group className='mb-3'>
                        <div className='badge badge-light-danger me-1'>{t('Reflection')}{' ' + (i + 1) + ':'}</div>
                        <Form.Label>
                          {t('Title')}
                        </Form.Label>
                        <Form.Control
                          type='text'
                          defaultValue={v.ib_essay_refd_name}
                          onChange={(e) =>
                            this.setReflectionDetailValue(i, 'ib_essay_refd_name', e.target.value)
                          }
                        />
                      </Form.Group>
                      {(v.ib_essay_refd_type == 'URL') &&
                        <Form.Group className='mb-3'>
                          <Form.Label>{t('URL')}</Form.Label>
                          <Form.Control
                            type='text'
                            defaultValue={v.ib_essay_refd_value}
                            onChange={(e) =>
                              this.setReflectionDetailValue(i, 'ib_essay_refd_value', e.target.value)
                            }
                          />
                        </Form.Group>
                      }
                      {(v.ib_essay_refd_type == 'Image' || v.ib_essay_refd_type == 'File') &&
                        <Form.Group controlId='formFile'>
                          <Form.Label>
                            {v.ib_essay_refd_type + ' ' + t('Attachment')}
                          </Form.Label>
                          <Form.Control
                            type='file'
                            onChange={(e) => this.setReflectionDetailValue(i, 'ib_essay_refd_value', e.target.files[0])}
                          />
                        </Form.Group>
                      }
                      {(v.ib_essay_refd_type == 'Image' && v.ib_essay_refd_value && (typeof v.ib_essay_refd_value == 'string')) && (
                        <div className='pic-prev d-flex justify-content-center'>
                          <img
                            alt=''
                            style={{ maxWidth: 270, height: '100%', }}
                            src={getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_ib_essay_reflection_details/' + v.ib_essay_refd_value}
                          />
                        </div>
                      )}
                      {(v.ib_essay_refd_type == 'File' && v.ib_essay_refd_value && (typeof v.ib_essay_refd_value == 'string')) && (
                        <div className='pic-prev d-flex justify-content-center'>
                          <a href={getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_ib_essay_reflection_details/' + v.ib_essay_refd_value} target='_blank'>Open File</a>
                        </div>
                      )}
                    </div>
                  </Col>
                })}
              </Row>
            </Modal.Body>
          }
          <Modal.Footer>
            <Button variant='secondary' onClick={addReflectionModal.toggle}>
              {t('Close')}
            </Button>
            <Button
              disabled={addReflectionModal.working}
              variant={addReflectionModal.isEditing ? 'warning' : 'success'}
              onClick={() => this.saveUpdateReflection()}>
              {addReflectionModal.isEditing ? t('Update') : t('Save')}{' '}
              {addReflectionModal.working && (
                <Spinner
                  as='span'
                  animation='grow'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                />
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ESSAY MODAL */}
        <Modal
          backdrop='static'
          keyboard={false}
          fullscreen
          show={this.state.showReflectionModal.show}
          onHide={this.handleCloseReflectionListModal}>
          <Modal.Header closeButton>
            <div className='w-100 d-flex flex-row justify-content-between'>
              <div style={{ flex: 1 }}>
                <Modal.Title style={{ fontSize: 20 }}>
                  {ibEssayData.ib_essay_name}
                  <GetIcon icon={'FaCircle'} className={'mx-2'} style={{ fontSize: 8, color: SoftGray }} />
                  {this.props.selectedChild.child_name}
                </Modal.Title>
              </div>
              <div className='d-flex flex-column justify-content-center align-items-end' style={{ flex: 1 }}>
                <ButtonGroup size='sm'>
                  <Button variant={(showReflectionModal.viewStyle == 'tab') ? 'primary' : 'light'} onClick={() => this.setState({ showReflectionModal: { ...this.state.showReflectionModal, viewStyle: 'tab' }, })}>
                    <GetIcon icon="LuColumns2" className={'me-1'} />
                    Tab View
                  </Button>
                  <Button variant={(showReflectionModal.viewStyle == 'timeline') ? 'primary' : 'light'} onClick={() => this.setState({ showReflectionModal: { ...this.state.showReflectionModal, viewStyle: 'timeline' }, }, () => this.getTimeline())}>
                    <GetIcon icon="LuText" className={'me-1'} />
                    Timeline View
                  </Button>
                </ButtonGroup>
              </div>
            </div>
          </Modal.Header>
          {this.state.showReflectionModal.show &&
            <Modal.Body className='p-0'>
              <div className='d-flex flex-row' style={{ fontSize: 12 }}>
                {/* LEFT */}
                <div style={{ width: '30%', minHeight: '85vh', height: '85vh' }} className='d-flex'>
                  <div style={{ backgroundColor: White, flex: 1 }} className='d-flex flex-column p-3'>
                    <div className='mb-3'>
                      <div style={{ fontWeight: 'bold' }}>Subject</div>
                      <div>{ibEssayData.acs_name}</div>
                    </div>
                    <div className='mb-3'>
                      <div style={{ fontWeight: 'bold' }}>Status</div>
                      {/* <div>{ibEssayData.ib_essay_status}</div> */}
                      <div className="mb-3">
                        {ibEssayData.ib_essay_status}
                      </div>
                      <div className="mb-1 d-flex flex-row align-items-center" style={{ fontSize: 14 }}>
                        <GetIcon icon={(ibEssayData.ib_essay_approved) ? 'LuCircleCheck' : 'LuCircleX'} style={{ color: (ibEssayData.ib_essay_approved) ? Taurus : RedLustre, fontSize: 16 }} />
                        <div className='ms-1'>{t('Approved')}</div>
                      </div>
                      <div className="mb-1 d-flex flex-row align-items-center" style={{ fontSize: 14 }}>
                        <GetIcon icon={(ibEssayData.ib_essay_completed) ? 'LuCircleCheck' : 'LuCircleX'} style={{ color: (ibEssayData.ib_essay_completed) ? Taurus : RedLustre, fontSize: 16 }} />
                        <div className='ms-1'>{t('Completed')}</div>
                      </div>
                    </div>
                    <div className='mb-3'>
                      <div style={{ fontWeight: 'bold' }}>Research Question</div>
                      <div>{ibEssayData.ib_essay_research_question}</div>
                    </div>
                    <div className='mb-3'>
                      <div style={{ fontWeight: 'bold' }}>Topic</div>
                      <div>{ibEssayData.ib_essay_topic}</div>
                    </div>
                    <div className='mb-3'>
                      <div style={{ fontWeight: 'bold' }}>Notes</div>
                      <div>{ibEssayData.ib_essay_note}</div>
                    </div>
                    <div className='mb-3'>
                      <div style={{ fontWeight: 'bold' }}>Supervisors</div>
                      <div className='d-flex flex-row flex-wrap'>
                        {ibEssayData.ib_essay_supervisors.map((v) =>
                          <div style={{ backgroundColor: WhiteMarble, color: Black, padding: '5px 10px', borderRadius: 5 }} className='d-flex flex-row align-items-center me-1 mb-1'>
                            {v.label}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* RIGHT */}
                <div style={{ width: '70%', minHeight: '85vh', height: '85vh' }} className='d-flex position-relative'>
                  <div className='grey-section p-3 m-0' style={{ flex: 1, borderRadius: 0, overflowY: 'auto' }}>
                    {/* TAB */}
                    {(showReflectionModal.viewStyle == 'tab') &&
                      <div className='' style={{ height: '100%' }}>

                        <Tab.Container defaultActiveKey={this.state.activeTab} style={{ flex: 1 }} onSelect={(activeTab) => this.setState({
                          activeTab
                        })}>
                          <div className='d-flex flex-column' style={{ height: '100%' }}>
                            <div className="d-flex flex-row align-items-start" style={{ height: '8%' }}>
                              <Nav className="d-flex flex-row flex-wrap" style={{ flex: 1 }}>
                                <Button variant='light' className='p-0 overflow-hidden me-1' style={{
                                  borderBottomLeftRadius: 0,
                                  borderBottomRightRadius: 0
                                }}>
                                  <Nav.Item>
                                    <Nav.Link eventKey="todo">TODO</Nav.Link>
                                  </Nav.Item>
                                </Button>
                                <Button variant='light' className='p-0 overflow-hidden me-1' style={{
                                  borderBottomLeftRadius: 0,
                                  borderBottomRightRadius: 0
                                }}>
                                  <Nav.Item>
                                    <Nav.Link eventKey="documents">DOCUMENTS</Nav.Link>
                                  </Nav.Item>
                                </Button>
                                <Button variant='light' className='p-0 overflow-hidden me-1' style={{
                                  borderBottomLeftRadius: 0,
                                  borderBottomRightRadius: 0
                                }}>
                                  <Nav.Item>
                                    <Nav.Link eventKey="reflections">REFLECTIONS</Nav.Link>
                                  </Nav.Item>
                                </Button>
                                <Button variant='light' className='p-0 overflow-hidden me-1' style={{
                                  borderBottomLeftRadius: 0,
                                  borderBottomRightRadius: 0
                                }}>
                                  <Nav.Item>
                                    <Nav.Link eventKey="notes">NOTES</Nav.Link>
                                  </Nav.Item>
                                </Button>
                                <Button variant='light' className='p-0 overflow-hidden me-1' style={{
                                  borderBottomLeftRadius: 0,
                                  borderBottomRightRadius: 0
                                }}>
                                  <Nav.Item>
                                    <Nav.Link eventKey="planning">PLANNING</Nav.Link>
                                  </Nav.Item>
                                </Button>
                              </Nav>
                              <div>
                                {this.state.activeTab == 'documents' &&
                                  <Button
                                    onClick={() => this.setState({ showDocumentModal: true })}
                                    variant='success'
                                    size='sm'>
                                    <GetIcon icon={'LuPlus'} /> {t('Document')}
                                  </Button>
                                }
                                {this.state.activeTab == 'reflections' &&
                                  <Button
                                    onClick={() => addReflectionModal.toggle({ ...this.defaultReflectionFields, ib_essay_id: this.state.ibEssayData.ib_essay_id, details: [] }, false)}
                                    variant='success'
                                    size='sm'>
                                    <GetIcon icon={'LuPlus'} /> {t('Reflection')}
                                  </Button>
                                }
                                {this.state.activeTab == 'notes' &&
                                  <Button
                                    onClick={() => this.setState({ showNoteModal: true })}
                                    variant='success'
                                    size='sm'>
                                    <GetIcon icon={'LuPlus'} /> {t('Note')}
                                  </Button>
                                }
                                {(this.state.activeTab == 'planning' && this.state.planningcdt.data.length < 3) &&
                                  <Button
                                    onClick={() => this.setState({ showPlanningModal: true })}
                                    variant='success'
                                    size='sm'>
                                    <GetIcon icon={'LuPlus'} /> {t('Plan')}
                                  </Button>
                                }
                              </div>
                            </div>
                            <Tab.Content style={{ height: '92%', backgroundColor: White, borderRadius: 5, }}>
                              <Tab.Pane eventKey="todo" style={{ height: '100%' }}>
                                <div style={{ height: '100%', overflowY: 'auto' }}>
                                  <div className='d-flex flex-row align-items-center mb-2 p-2'>
                                    <div style={{ flex: 3 }} className='pe-2'>
                                      <Form.Control
                                        placeholder={t('Todo Description')}
                                        type='text'
                                        value={this.state.ib_essay_todo_desc}
                                        onChange={(e) =>
                                          this.setState({ ib_essay_todo_desc: e.target.value })
                                        }
                                      />
                                    </div>
                                    <div style={{ flex: 1.2 }} className='pe-3'>
                                      <DatePicker
                                        placeholderText={t('Due Date')}
                                        selected={this.state.ib_essay_todo_date}
                                        onChange={(date) =>
                                          this.setState({ ib_essay_todo_date: date })
                                        }
                                        selectsStart
                                        dateFormat={'dd-MM-yyyy'}
                                      />
                                    </div>
                                    <div>
                                      <Button variant='success' onClick={() => this.addTodo()}>
                                        <GetIcon icon={'LuPlus'} />
                                      </Button>
                                    </div>
                                  </div>

                                  {this.state.todo.map((item, index) => {
                                    return <div className='p-2 mb-2 d-flex flex-row justify-content-between align-items-center' style={{ backgroundColor: Lotion, borderRadius: 10 }}>
                                      <div style={{ flex: 3 }}>{item.ib_essay_todo_desc}</div>
                                      <div className='px-2'>
                                        <div style={{ backgroundColor: WhiteMarble, color: Black, padding: '5px 10px', borderRadius: 5 }} className='d-flex flex-row align-items-center'>
                                          <GetIcon icon={'LuCalendar1'} className={'me-1'} style={{ fontSize: 15 }} />
                                          {moment(item.ib_essay_todo_date).format('DD-MM-YYYY')}
                                        </div>
                                      </div>
                                      <div className='ps-3'>
                                        {/* <Button variant='danger' size='sm' onClick={() => this.deleteTodo(item)}>
                                          <GetIcon icon={'LuTrash2'} style={{ fontSize: 15 }} />
                                        </Button> */}
                                      </div>
                                    </div>
                                  })}
                                </div>
                              </Tab.Pane>
                              <Tab.Pane eventKey="documents" style={{ height: '100%' }}>
                                <div style={{ height: '85%', overflowY: 'auto' }}>
                                  {this.state.docscdt.fetching && (
                                    <div
                                      className='py-5 d-flex flex-column align-items-center'>
                                      <Spinner as='span' animation='grow' size='sm' />{' '}
                                      {t('Loading Data')}
                                    </div>
                                  )}
                                  {!this.state.docscdt.fetching && this.state.docscdt.data.length === 0 && (
                                    <div
                                      className='py-5 d-flex flex-column align-items-center'>
                                      {t('No Data Found')}
                                    </div>
                                  )}

                                  {!this.state.docscdt.fetching && this.state.docscdt.data.length !== 0 && this.state.docscdt.data.map((item, index) => (
                                    <div className='p-2 mb-2 d-flex flex-row justify-content-between align-items-center' style={{ backgroundColor: Lotion, borderRadius: 10 }}>
                                      <div className='d-flex flex-row align-items-center' style={{ flex: 1 }}>
                                        <div style={{ backgroundColor: WhiteMarble, color: Black, padding: '5px 10px', borderRadius: 5 }} className='d-flex flex-row align-items-center'>
                                          <GetIcon icon={'LuCalendar1'} className={'me-1'} style={{ fontSize: 15 }} />
                                          {moment(item.ib_essay_doc_date).format('DD-MM-YYYY')}
                                        </div>
                                        <div style={{ backgroundColor: SilentPink, color: Black, padding: '5px 10px', borderRadius: 5 }} className='d-flex flex-row align-items-center ms-1'>
                                          <GetIcon icon={'LuUser'} className={'me-1'} style={{ fontSize: 15 }} />
                                          {item.created_by_name}
                                        </div>
                                        <Button variant='link' className='ms-2 p-0' onClick={() => {
                                          let url = getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_ib_essay_documents/' + item.ib_essay_doc_name;
                                          window.open(url, '_blank');
                                        }}>
                                          {item.ib_essay_doc_caption}
                                        </Button>
                                      </div>
                                      <div className='d-flex flex-row align-items-center'>
                                        {this.props.selectedChild.child_user_id == item.created_by &&
                                          <Button variant='warning' className='me-1'
                                            onClick={() => this.editDoc(item)}
                                            size='sm'>
                                            <FontAwesomeIcon icon={faPencil} />
                                          </Button>
                                        }
                                        {this.props.selectedChild.child_user_id == item.created_by &&
                                          <Button variant='danger'
                                            onClick={() => this.deleteDoc(item)}
                                            size='sm'>
                                            <FontAwesomeIcon icon={faTrash} />
                                          </Button>
                                        }
                                      </div>
                                    </div>
                                  ))}
                                </div>
                                <div className='d-flex justify-content-center align-items-center' style={{ height: '15%' }}>
                                  <Pagination
                                    pageCount={this.state.docscdt.lastPage || 1}
                                    forcePage={this.state.docscdt.page}
                                    callbackParams={{
                                      search: this.state.docscdt.search,
                                      limit: this.state.docscdt.rows,
                                      order: this.state.docscdt.order,
                                      dir: this.state.docscdt.dir,
                                    }}
                                    callback={this.getDocs}
                                  />
                                </div>
                              </Tab.Pane>
                              <Tab.Pane eventKey="reflections" style={{ height: '100%' }}>
                                <div style={{ height: '85%', overflowY: 'auto' }}>
                                  {this.state.refcdt.fetching && (
                                    <div
                                      className='py-5 d-flex flex-column align-items-center'>
                                      <Spinner as='span' animation='grow' size='sm' />{' '}
                                      {t('Loading Data')}
                                    </div>
                                  )}
                                  {!this.state.refcdt.fetching && this.state.refcdt.data.length === 0 && (
                                    <div
                                      className='py-5 d-flex flex-column align-items-center'>
                                      {t('No Data Found')}
                                    </div>
                                  )}

                                  {!this.state.refcdt.fetching && this.state.refcdt.data.length !== 0 && this.state.refcdt.data.map((item, index) => (
                                    <div className='p-2 mb-2 d-flex flex-column' style={{ backgroundColor: Lotion, borderRadius: 10 }}>
                                      <div className='d-flex flex-row justify-content-between align-items-center'>
                                        <div className='d-flex flex-row align-items-center' style={{ flex: 1 }}>
                                          {item.ib_essay_ref_date &&
                                            <div style={{ backgroundColor: WhiteMarble, color: Black, padding: '5px 10px', borderRadius: 5 }} className='d-flex flex-row align-items-center'>
                                              <GetIcon icon={'LuCalendar1'} className={'me-1'} style={{ fontSize: 15 }} />
                                              {moment(item.ib_essay_ref_date).format('DD-MM-YYYY')}
                                            </div>
                                          }
                                          <div style={{ backgroundColor: SilentPink, color: Black, padding: '5px 10px', borderRadius: 5 }} className='d-flex flex-row align-items-center ms-2'>
                                            <GetIcon icon={'LuUser'} className={'me-1'} style={{ fontSize: 15 }} />
                                            {item.created_by_name}
                                          </div>
                                          <div className='mx-2' style={{ fontWeight: 'bold' }}>{item.ib_essay_ref_title}</div>
                                        </div>
                                        <div>
                                          {item.ib_essay_ref_approved == 1 &&
                                            <Badge bg='success' className='me-2'><FontAwesomeIcon icon={faCheck} /> {t('Approved')}</Badge>
                                          }
                                          {this.props.selectedChild.child_user_id == item.created_by &&
                                            <Button variant='warning' className='me-2'
                                              onClick={() => this.editReflection(item)}
                                              size='sm'>
                                              <FontAwesomeIcon icon={faPencil} />
                                            </Button>
                                          }
                                        </div>
                                      </div>
                                      <div className='my-1'>
                                        <div dangerouslySetInnerHTML={{ __html: item.ib_essay_ref_desc }} />
                                      </div>
                                      <div>
                                        {item.ib_essay_ref_target_outcome && JSON.parse(item.ib_essay_ref_target_outcome).map((item, index) => <Badge key={index} bg='warning' className='me-2'>{item}</Badge>)}
                                      </div>
                                      <div>
                                        {item.reflection_details.map((item2, index2) => {
                                          let icon = null;
                                          let url = null;

                                          if (item2.ib_essay_refd_type == 'URL') {
                                            icon = faGlobe;
                                            url = makeURL(item2.ib_essay_refd_value)
                                          } else if (item2.ib_essay_refd_type == 'Image') {
                                            icon = faImage;
                                            url = getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_ib_essay_reflection_details/' + item2.ib_essay_refd_value;
                                          } else if (item2.ib_essay_refd_type == 'File') {
                                            icon = faFolder;
                                            url = getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_ib_essay_reflection_details/' + item2.ib_essay_refd_value;
                                          }

                                          const name = item2.ib_essay_refd_name ? item2.ib_essay_refd_name : item2.ib_essay_refd_type;

                                          return (<div style={{ display: 'inline-block', position: 'relative' }} key={index2}>
                                            {this.props.selectedChild.child_user_id == item.created_by &&
                                              <Button variant='danger' size="sm" style={{ width: 20, height: 20, borderRadius: 10, padding: 0, lineHeight: '10px', position: 'absolute', top: -7, right: 5 }} onClick={() => this.setState({ deleteModal: { show: true, id: item2.ib_essay_refd_id, action: this.delRefDetail } })}>
                                                <FontAwesomeIcon icon={faTrashCan} style={{ fontSize: 10 }} />
                                              </Button>
                                            }
                                            <Button
                                              onClick={() => {
                                                window.open(url, '_blank');
                                              }}
                                              key={index2}
                                              variant='outline-dark'
                                              size='sm'
                                              className='me-3'>
                                              <FontAwesomeIcon icon={icon} /> {name}
                                            </Button>
                                          </div>)
                                        })}
                                      </div>

                                    </div>
                                  ))}
                                </div>
                                <div className='d-flex justify-content-center align-items-center' style={{ height: '15%' }}>
                                  <Pagination
                                    pageCount={this.state.refcdt.lastPage || 1}
                                    forcePage={this.state.refcdt.page}
                                    callbackParams={{
                                      search: this.state.refcdt.search,
                                      limit: this.state.refcdt.rows,
                                      order: this.state.refcdt.order,
                                      dir: this.state.refcdt.dir,
                                    }}
                                    callback={this.getReflections}
                                  />
                                </div>
                              </Tab.Pane>
                              <Tab.Pane eventKey="notes" style={{ height: '100%' }}>
                                <div style={{ height: '85%', overflowY: 'auto' }}>
                                  {this.state.notescdt.fetching && (
                                    <div
                                      className='py-5 d-flex flex-column align-items-center'>
                                      <Spinner as='span' animation='grow' size='sm' />{' '}
                                      {t('Loading Data')}
                                    </div>
                                  )}
                                  {!this.state.notescdt.fetching && this.state.notescdt.data.length === 0 && (
                                    <div
                                      className='py-5 d-flex flex-column align-items-center'>
                                      {t('No Data Found')}
                                    </div>
                                  )}

                                  {!this.state.notescdt.fetching && this.state.notescdt.data.length !== 0 && this.state.notescdt.data.map((item, index) => (
                                    <div className='p-2 mb-2 d-flex flex-column ' style={{ backgroundColor: Lotion, borderRadius: 10 }}>
                                      <div className='d-flex flex-row justify-content-between align-items-center mb-1'>
                                        <div className='d-flex flex-row align-items-center' style={{ flex: 1 }}>
                                          <div style={{ backgroundColor: WhiteMarble, color: Black, padding: '5px 10px', borderRadius: 5 }} className='d-flex flex-row align-items-center'>
                                            <GetIcon icon={'LuCalendar1'} className={'me-1'} style={{ fontSize: 15 }} />
                                            {moment(item.created_on).format('DD-MM-YYYY')}
                                          </div>
                                          <div style={{ backgroundColor: SilentPink, color: Black, padding: '5px 10px', borderRadius: 5 }} className='d-flex flex-row align-items-center ms-1'>
                                            <GetIcon icon={'LuUser'} className={'me-1'} style={{ fontSize: 15 }} />
                                            {item.created_by_name}
                                          </div>
                                        </div>
                                        <div className='d-flex flex-row align-items-center'>
                                          {this.props.selectedChild.child_user_id == item.created_by &&
                                            <Button variant='warning' className='me-1'
                                              onClick={() => this.editNote(item)}
                                              size='sm'>
                                              <FontAwesomeIcon icon={faPencil} />
                                            </Button>
                                          }
                                          {this.props.selectedChild.child_user_id == item.created_by &&
                                            <Button variant='danger'
                                              onClick={() => this.deleteNote(item)}
                                              size='sm'>
                                              <FontAwesomeIcon icon={faTrash} />
                                            </Button>
                                          }
                                        </div>
                                      </div>
                                      <div>{item.ib_essay_note}</div>
                                    </div>
                                  ))}
                                </div>
                                <div className='d-flex justify-content-center align-items-center' style={{ height: '15%' }}>
                                  <Pagination
                                    pageCount={this.state.notescdt.lastPage || 1}
                                    forcePage={this.state.notescdt.page}
                                    callbackParams={{
                                      search: this.state.notescdt.search,
                                      limit: this.state.notescdt.rows,
                                      order: this.state.notescdt.order,
                                      dir: this.state.notescdt.dir,
                                    }}
                                    callback={this.getNotes}
                                  />
                                </div>
                              </Tab.Pane>
                              <Tab.Pane eventKey="planning" style={{ height: '100%' }}>
                                <div style={{ height: '85%', overflowY: 'auto' }}>
                                  {this.state.planningcdt.fetching && (
                                    <div
                                      className='py-5 d-flex flex-column align-items-center'>
                                      <Spinner as='span' animation='grow' size='sm' />{' '}
                                      {t('Loading Data')}
                                    </div>
                                  )}
                                  {!this.state.planningcdt.fetching && this.state.planningcdt.data.length === 0 && (
                                    <div
                                      className='py-5 d-flex flex-column align-items-center'>
                                      {t('No Data Found')}
                                    </div>
                                  )}

                                  {!this.state.planningcdt.fetching && this.state.planningcdt.data.length !== 0 && this.state.planningcdt.data.map((item, index) => (
                                    <div className='p-2 mb-2 d-flex flex-column ' style={{ backgroundColor: Lotion, borderRadius: 10 }}>
                                      <div className='d-flex flex-row justify-content-between align-items-center mb-1'>
                                        <div className='d-flex flex-row align-items-center' style={{ flex: 1 }}>
                                          <div style={{ backgroundColor: WhiteMarble, color: Black, padding: '5px 10px', borderRadius: 5 }} className='d-flex flex-row align-items-center'>
                                            <GetIcon icon={'LuCalendar1'} className={'me-1'} style={{ fontSize: 15 }} />
                                            {moment(item.ib_essay_plan_date).format('DD-MM-YYYY')}
                                          </div>
                                          <div style={{ backgroundColor: SilentPink, color: Black, padding: '5px 10px', borderRadius: 5 }} className='d-flex flex-row align-items-center ms-1'>
                                            <GetIcon icon={'LuUser'} className={'me-1'} style={{ fontSize: 15 }} />
                                            {item.created_by_name}
                                          </div>
                                        </div>
                                        <div className='d-flex flex-row align-items-center'>
                                          {this.props.selectedChild.child_user_id == item.created_by &&
                                            <Button variant='warning' className='me-1'
                                              onClick={() => this.editPlanning(item)}
                                              size='sm'>
                                              <FontAwesomeIcon icon={faPencil} />
                                            </Button>
                                          }
                                          {this.props.selectedChild.child_user_id == item.created_by &&
                                            <Button variant='danger'
                                              onClick={() => this.deletePlanning(item)}
                                              size='sm'>
                                              <FontAwesomeIcon icon={faTrash} />
                                            </Button>
                                          }
                                        </div>
                                      </div>
                                      <div>{item.ib_essay_plan_text}</div>
                                    </div>
                                  ))}
                                </div>
                                <div className='d-flex justify-content-center align-items-center' style={{ height: '15%' }}>
                                  <Pagination
                                    pageCount={this.state.planningcdt.lastPage || 1}
                                    forcePage={this.state.planningcdt.page}
                                    callbackParams={{
                                      search: this.state.planningcdt.search,
                                      limit: this.state.planningcdt.rows,
                                      order: this.state.planningcdt.order,
                                      dir: this.state.planningcdt.dir,
                                    }}
                                    callback={this.getPlanning}
                                  />
                                </div>
                              </Tab.Pane>
                            </Tab.Content>
                          </div>
                        </Tab.Container>
                      </div>
                    }
                    {(showReflectionModal.viewStyle == 'timeline') &&
                      <div className='d-flex flex-column'>
                        {/* TIME CARD START */}
                        {getTimelineData.data.map((getTimelineData_v, getTimelineData_i) => {
                          return <div className='d-flex flex-row mb-2'>
                            <div style={{ flex: 1 }} className='d-flex flex-row justify-content-end align-items-start'>
                              {/* DATE */}
                              <div style={{ backgroundColor: WhiteMarble, color: Black, padding: '5px 10px', borderRadius: 5, position: 'sticky', top: 0, opacity: (getTimelineData_v.uniqueDate) ? 1 : 0.3 }} className='d-flex flex-row align-items-center'>
                                <GetIcon icon={'LuCalendar1'} className={'me-1'} style={{ fontSize: 15 }} />
                                {moment(getTimelineData_v.date).format('DD-MM-YYYY')}
                              </div>
                            </div>
                            {/* TIMELINE CARD */}
                            <div className='d-flex flex-column justify-content-center px-2' style={{ flex: 2.5, opacity: (getTimelineData_v.hidden) ? 0.3 : 1 }}>
                              <div className='p-2 d-flex flex-column' style={{ backgroundColor: White, borderRadius: 5 }}>
                                <div className='d-flex flex-row justify-content-between'>
                                  <div className='d-flex flex-row justify-content-between'>
                                    {getTimelineData_v.created_by_name &&
                                      <div style={{ backgroundColor: SilentPink, color: Black, padding: '5px 10px', borderRadius: 5 }} className='d-flex flex-row align-items-center me-1'>
                                        <GetIcon icon={'LuUser'} className={'me-1'} style={{ fontSize: 15 }} />
                                        {getTimelineData_v.created_by_name}
                                      </div>
                                    }
                                    <div style={{ backgroundColor: WhiteMarble, color: Black, padding: '5px 10px', borderRadius: 5 }} className='d-flex flex-row align-items-center'>
                                      <GetIcon icon={'LuCalendar1'} className={'me-1'} style={{ fontSize: 15 }} />
                                      {getTimelineData_v.typeName}
                                    </div>
                                  </div>
                                </div>
                                {getTimelineData_v.title &&
                                  <div style={{ fontWeight: 'bold' }} className='mt-2'>{getTimelineData_v.title}</div>
                                }
                                {getTimelineData_v.description &&
                                  <div className='mt-1' dangerouslySetInnerHTML={{ __html: getTimelineData_v.description }} />
                                }

                                {getTimelineData_v?.attachment &&
                                  <div>
                                    <div className='mt-1 me-3' style={{ display: 'inline-block', position: 'relative' }} >
                                      <Button
                                        onClick={() => {
                                          window.open(getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/' + getTimelineData_v.type + '/' + getTimelineData_v.attachment, '_blank');
                                        }}
                                        variant='outline-dark'
                                        size='sm'
                                      >
                                        <FontAwesomeIcon icon={faFolder} /> {'File'}
                                      </Button>
                                    </div>
                                  </div>
                                }
                                {getTimelineData_v?.reflection_details &&
                                  <div >
                                    {getTimelineData_v?.reflection_details.map((item, index) => {
                                      let icon = null;
                                      let url = null;

                                      if (item.ib_essay_refd_type == 'URL') {
                                        icon = faGlobe;
                                        url = makeURL(item.ib_essay_refd_value)
                                      } else if (item.ib_essay_refd_type == 'Image') {
                                        icon = faImage;
                                        url = getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_ib_essay_reflection_details/' + item.ib_essay_refd_value;
                                      } else if (item.ib_essay_refd_type == 'File') {
                                        icon = faFolder;
                                        url = getRegionalStorageURL() + this.props.authData.centerData.center_uuid + '/academic_ib_essay_reflection_details/' + item.ib_essay_refd_value;
                                      }

                                      const name = item.ib_essay_refd_name ? item.ib_essay_refd_name : item.ib_essay_refd_type;

                                      return (<div className='mt-1 me-3' style={{ display: 'inline-block', position: 'relative' }} key={index}>
                                        <Button
                                          onClick={() => {
                                            window.open(url, '_blank');
                                          }}
                                          key={index}
                                          variant='outline-dark'
                                          size='sm'
                                        >
                                          <FontAwesomeIcon icon={icon} /> {name}
                                        </Button>
                                      </div>)
                                    })}
                                  </div>
                                }
                              </div>
                            </div>
                            <div style={{ flex: 1 }} className='d-flex flex-row justify-content-start align-items-start'>
                              {/* PRINT HIDDEN */}
                              <div style={{ padding: '5px 10px', }} className='d-flex flex-row align-items-center'>
                                <div className='cursor-pointer' onClick={() => {
                                  getTimelineData.data[getTimelineData_i].hidden = !getTimelineData.data[getTimelineData_i].hidden
                                  this.setState({ getTimelineData })
                                }}>
                                  <GetIcon icon={(getTimelineData_v.hidden) ? 'LuEyeOff' : 'LuEye'} style={{ fontSize: 20, color: NewGray }} />
                                </div>
                              </div>
                            </div>
                          </div>
                        })}
                      </div>
                    }
                    {(showReflectionModal.viewStyle == 'timeline') &&
                      <div style={{ position: 'absolute', bottom: 30, right: 15 }}>
                        <Button variant='light' size='sm' style={{ fontSize: 12 }}>
                          <GetIcon icon={'LuPrinter'} className={'me-1'} style={{ fontSize: 15 }} />
                          PRINT
                        </Button>
                      </div>
                    }

                  </div>
                </div>
              </div>
            </Modal.Body>
          }
        </Modal>

        {/* Todo Modal */}
        <Modal
          backdrop='static'
          keyboard={false}
          size={'lg'}
          show={this.state.showTodoModal}
          onHide={this.handleCloseTodoModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              {t('Todo')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className='mb-2'>
              <Col md={7} className='pe-0'>
                <Form.Control
                  placeholder={t('Todo Description')}
                  type='text'
                  value={this.state.ib_essay_todo_desc}
                  onChange={(e) =>
                    this.setState({ ib_essay_todo_desc: e.target.value })
                  }
                />
              </Col>
              <Col md={4} className='pe-0'>
                <DatePicker
                  placeholderText={t('Due Date')}
                  selected={this.state.ib_essay_todo_date}
                  onChange={(date) =>
                    this.setState({ ib_essay_todo_date: date })
                  }
                  selectsStart
                  dateFormat={'dd-MM-yyyy'}
                />
              </Col>
              <Col md={1}>
                <Button variant='success' onClick={() => this.addTodo()}>
                  <FontAwesomeIcon className='me-1' icon={faPlus} />
                </Button>
              </Col>
            </Row>
            {this.state.todo.map((item, index) => (
              <Row key={index} className='mb-2'>
                <Col md={7} className='d-flex align-items-center ps-4'>{item.ib_essay_todo_desc}</Col>
                <Col md={4} className='d-flex align-items-center ps-4'>{moment(item.ib_essay_todo_date).format('DD-MM-YYYY')}</Col>
                <Col md={1}>
                  <Button variant='danger' onClick={() => this.deleteTodo(item)}>
                    <FontAwesomeIcon className='me-1' icon={faTrash} />
                  </Button>
                </Col>
              </Row>
            ))}
          </Modal.Body>
        </Modal>

        {/* DOCUMENT MODAL */}
        <Modal backdropClassName='second-backdrop' backdrop='static' keyboard={false} show={this.state.showDocumentModal} onHide={this.handleCloseDocumentModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.editDocumentModal ? t('Edit') : t('Add')} {t('Document')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId='formFile'>
              <Row>
                <Col>
                  <Form.Control
                    className='mb-3'
                    placeholder={t('Caption')}
                    type='text'
                    value={this.state.ib_essay_doc_caption}
                    onChange={(e) => this.setState({ ib_essay_doc_caption: e.target.value })}
                  />
                </Col>
                <Col>
                  <DatePicker
                    selected={this.state.ib_essay_doc_date}
                    onChange={(date) =>
                      this.setState({ ib_essay_doc_date: date })
                    }
                    selectsStart
                    dateFormat={'dd-MM-yyyy'}
                  />
                </Col>
              </Row>
              {!this.state.editDocumentModal &&
                <>
                  <Form.Control
                    ref={this.docRef}
                    type='file'
                    onChange={(e) => {
                      const selectedFile = e.target.files[0];
                      if (selectedFile.size > 10 * 1024 * 1024) {
                        toast.error(t('Allowed file size is 10MB!'));
                        this.docRef.current.value = '';
                        return;
                      }
                      this.setState({ ib_essay_doc_name: selectedFile })
                    }}
                  />
                  <div className='text-end'>
                    <small className='text-danger'>{t('Allowed file size:')} <strong>10MB</strong></small>
                  </div>
                </>
              }
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={this.handleCloseDocumentModal}>
              {t('Close')}
            </Button>
            <Button
              disabled={this.state.EssayDocWorking}
              variant={'success'}
              onClick={() => this.saveUpdateEssayDoc()}>
              {t('Save')}{' '}
              {this.state.EssayDocWorking && (
                <Spinner
                  as='span'
                  animation='grow'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                />
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* NOTE MODAL */}
        <Modal backdropClassName='second-backdrop' backdrop='static' keyboard={false} show={this.state.showNoteModal} onHide={this.handleCloseNoteModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.editNoteModal ? t('Edit') : t('Add')} {t('Note')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId='formFile'>
              <Form.Control
                className='mb-3'
                placeholder={t('Note')}
                as="textarea" rows={3}
                value={this.state.ib_essay_note}
                onChange={(e) => this.setState({ ib_essay_note: e.target.value })}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={this.handleCloseNoteModal}>
              {t('Close')}
            </Button>
            <Button
              disabled={this.state.EssayNoteWorking}
              variant={'success'}
              onClick={() => this.saveUpdateEssayNote()}>
              {t('Save')}{' '}
              {this.state.EssayNoteWorking && (
                <Spinner
                  as='span'
                  animation='grow'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                />
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* PLANNING MODAL */}
        <Modal backdropClassName='second-backdrop' backdrop='static' keyboard={false} show={this.state.showPlanningModal} onHide={this.handleClosePlanningModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.editPlanningModal ? t('Edit') : t('Add')} {t('Plan')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={12}>
                <Form.Group controlId='formFile'>
                  <Form.Control
                    className='mb-3'
                    placeholder={t('Write here...')}
                    as="textarea" rows={3}
                    value={this.state.ib_essay_plan_text}
                    onChange={(e) => this.setState({ ib_essay_plan_text: e.target.value })}
                  />
                </Form.Group>
              </Col>
              <Col md={12}>
                <DatePicker
                  selected={this.state.ib_essay_plan_date}
                  onChange={(date) =>
                    this.setState({ ib_essay_plan_date: date })
                  }
                  selectsStart
                  dateFormat={'dd-MM-yyyy'}
                />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={this.handleClosePlanningModal}>
              {t('Close')}
            </Button>
            <Button
              disabled={this.state.EssayPlanningWorking}
              variant={'success'}
              onClick={() => this.saveUpdateEssayPlanning()}>
              {t('Save')}{' '}
              {this.state.EssayPlanningWorking && (
                <Spinner
                  as='span'
                  animation='grow'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                />
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        <SweetAlert show={this.state.deleteModal.show} warning showCancel confirmBtnText={t('Yes, delete it!')} confirmBtnBsStyle='danger' title={t('Are you sure?')} onConfirm={this.state.deleteModal.action} onCancel={() => this.setState({ deleteModal: { ...this.state.deleteModal, show: false, id: 0, action: () => { } } })} focusCancelBtn>
          {t('Confirm Delete!')}
        </SweetAlert>

      </Container >
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  defaultLanguage: state.language.defaultLanguage,
  selectedChild: state.selectedChild.data,
});

export default connect(mapStateToProps, null)(Essay);
